import { createImmutableMap } from 'ctm-util-functions';

export const createContentReducer = (initialState) => {
    const immutableInitialState = createImmutableMap(initialState);
    return (state = immutableInitialState, action) => {
        switch (action.type) {
            case 'SET_CONTENT': {
                return state.merge(action.value);
            }
            default: {
                return state;
            }
        }
    };
};
